<h1 id="title" class="title">Forgot Password</h1>
<p class="sub-title">Enter your username and we'll send a password reset link to your registered email address</p>

<nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
    <p class="alert-title"><b>Password reset Failed!</b></p>
    <ul class="alert-message-list">
        <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
    </ul>
</nb-alert>

<nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert">
    <p class="alert-title"><b>Success!</b></p>
    <ul class="alert-message-list">
        <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
    </ul>
</nb-alert>

<form (ngSubmit)="requestPass()" #requestPassForm="ngForm" aria-labelledby="title">
    <div class="form-control-group">
        <label class="label" for="input-username">Enter your username</label>
        <input
            nbInput
            [(ngModel)]="user.username"
            #username="ngModel"
            id="input-username"
            name="username"
            pattern="[\.@\w]+"
            placeholder="Username"
            autofocus
            fullWidth
            fieldSize="large"
            [status]="username.dirty ? (username.invalid ? 'danger' : 'success') : 'basic'"
            [required]="true"
            [attr.aria-invalid]="username.invalid && username.touched ? true : null"
        />
        <ng-container *ngIf="username.invalid && username.touched">
            <p class="caption status-danger" *ngIf="username.errors?.required">Username is required.</p>
            <p class="caption status-danger" *ngIf="username.errors?.pattern">Invalid username.</p>
        </ng-container>
    </div>

    <button
        nbButton
        fullWidth
        status="primary"
        size="large"
        [disabled]="submitted || !requestPassForm.valid"
        [class.btn-pulse]="submitted"
    >
        Request password
    </button>
</form>

<section class="sign-in-or-up" aria-label="Sign in">
    <p><a class="text-link" routerLink="../login">Back to Login</a></p>
</section>
